import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, ModuleFE_Toaster, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { compare, Second } from '@nu-art/ts-common';
export class QRangeInput extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        if (!compare(nextProps.value, state.value))
            state.value = nextProps.value || [undefined, undefined];
        return state;
    }
    toastError = (message) => {
        ModuleFE_Toaster.toastError(message, 3 * Second);
    };
    translateValueToString = (value) => {
        if (!value)
            return '';
        if (value[0] === undefined || value[1] === undefined)
            return '';
        if (value[0] === value[1])
            return `${(value[0] || value[0] === 0) ? value[0] : ''}`;
        return `${value[0]} - ${value[1]}`;
    };
    translateStringIntoValue = (str) => {
        if (str.length === 0)
            return undefined;
        const split = str.split('-').map(i => i.trim());
        if (split.length !== 1 && split.length !== 2) {
            this.toastError('Parsing Error');
            return undefined;
        }
        //Potential 1 number
        if (split.length === 1 && split[0].length > 0) {
            const number = Number(split[0]);
            if (isNaN(number)) {
                this.toastError('Value given is not a number');
                return undefined;
            }
            return [number, number];
        }
        if (split.some(i => !i)) {
            this.toastError('Value must be single number or number - number');
            return undefined;
        }
        //Potential 2 numbers
        const range = split.map(i => Number(i));
        if (range.some(i => isNaN(i))) {
            this.toastError('Value given is not a range');
            return undefined;
        }
        if (range[0] > range[1]) {
            this.toastError('Range max can\'t be lower than range min');
            return undefined;
        }
        return range;
    };
    render() {
        const valueAsString = this.translateValueToString(this.state.value);
        return _jsx(TS_Input, { disabled: this.props.disabled, placeholder: this.props.placeholder, type: 'text', value: valueAsString, onBlur: (str) => {
                const value = this.translateStringIntoValue(str);
                // if (!value)
                // 	return;
                if (compare(value, this.state.value))
                    return;
                this.setState({ value: value ? [value[0], value[1]] : [undefined, undefined] });
                this.props.onValueBlur?.(value);
            } });
    }
}
//# sourceMappingURL=QRangeInput.js.map